import React from "react";
import { useNavigate } from "react-router-dom";
import "./RefresherTraining.css";

const RefresherTraining = () => {
  const navigate = useNavigate();

  return (
    <div className="training-container">
      <h2 className="title">
        Free One-Day Refresher Training Programme for HMV Drivers
      </h2>

      <p className="description">
        The RDTC Singawal, Ajmer, under the aegis of Shri Ram Sewa Sankalp &
        D.B. Skill, organized Free One-Day Driver Refresher Training Programme
        for Heavy Motor Vehicle (HMV) drivers during this quarter.
      </p>

      <section className="training-section">
        <h3>Training Coverage</h3>
        <ul>
          <li>Road safety, defensive driving & Good Samaritan Laws</li>
          <li>Stress management & behavioural practices</li>
          <li>Vehicle maintenance, fuel conservation & pollution control</li>
        </ul>
      </section>

      <section className="training-section">
        <h3>Safety Clinic for Accident-Prone Drivers</h3>
        <ol>
          <li>
            <strong>Facilities Provided:</strong> Lunch, tea, driver kit (bag,
            blanket, cap, T-shirt)
          </li>
          <li>
            <strong>Social Security:</strong> Free ABHA Insurance Card with ₹5
            lakh coverage
          </li>
          <li>
            <strong>Certification:</strong> Computer-Based Test (CBT) by LSC,
            with successful drivers certified under NSQF Level-4 (NSDC)
          </li>
        </ol>
      </section>

      <div className="button-container">
        <button className="back-button" onClick={() => navigate("/")}>
          Back to Home
        </button>
      </div>
    </div>
  );
};

export default RefresherTraining;
